import { useEffect, useState } from "react";
import usersApi from "../../api/user/user";
import { ui } from "../../helpers/ui";

const InitSalaryLogic = () => {
  const [user, setUser] = useState<any>();

  const loadUser = () => {
    usersApi
      .getMe()
      .then((response) => {
        if (response.status === 200) {
          setUser(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    loadUser();
  }, []);

  return {
    user,
  };
};

export default InitSalaryLogic;
